<div class="audio-container player-audio-subtitles__container__column">
  <h1 class="player-audio-subtitles__container__column__title">
    {{ 'player.audio' | translate }}
  </h1>
  <div class="audio-vcontainer vertical-focusable-container" role="region" [attr.aria-label]="'player.audio' | translate">
    <div *ngFor="let track of audioTrackList; let i = index" tabindex="0" 
    class="player-audio-subtitles__container__column__menu-option focusable-element"
    [attr.aria-label]="('lang.' + track.language) | translate"
    [ngClass]="{ 'selected' : track.active}" (click)="selectTrack(track)"
      (mouseenter)="mouseEnter($event, i)" (keydown.ArrowRight)="goToSubtitles()">
      {{ 'lang.' + track.language | translate }}
      <app-icon class="mini-check-icon" name="mini-check"></app-icon>
    </div>
  </div>
</div>